import React, { useEffect, useState } from 'react';
import {
  Container,
  ContentContainer,
  LeftSide,
  RightSide,
  ProfileContainer,
  CheckboxContainer,
  Text,
  Title,
  SubTitle,
  Column2,
  UploadContainer,
  Row2,
  Text2,
  UnderlineText2,
  ThinText,
  Fade,
  AddPhotoContainer,
  InputLink,
  ImagesContainer,
  InputContainer,
  AddInputContainer,
  EditContainer,
  IconsContainer,
  ImageContainer,
  CloseIcon,
  LoaderContainer,
  StyledInput,
  IconContainer,
  UploadInput,
  UploadInputBig,
  UploadInputSmall,
  BankCard,
  StyledColumn,
  TitleContainer,
  UnderLineText,
  Column,
  Row,
  StyledText,
  MediaCard,
  ButtonContainer,
  StyledButton,
  ButtonText,
  TextDesc,
  TextDescAddress,
} from './ProfilePage.styles';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import { ReactComponent as Instagram } from '../../assets/icons/instagram1.svg';
import { ReactComponent as X } from '../../assets/icons/x.svg';
import { ReactComponent as Tiktok } from '../../assets/icons/tiktok.svg';
import { ReactComponent as Facebook } from '../../assets/icons/facebook.svg';
import { ReactComponent as Youtube } from '../../assets/icons/yt.svg';
import { ReactComponent as Website } from '../../assets/icons/website.svg';
import { ReactComponent as AddPhoto } from '../../assets/icons/addPhotoBlack.svg';
import { ReactComponent as Minus } from '../../assets/icons/minus.svg';
import Checkbox from '../../components/utils/Checkbox/Checkbox';
import { ReactComponent as XIcon } from '../../assets/icons/close.svg';
import { ReactComponent as CardIcon } from '../../assets/icons/card.svg';
import { ReactComponent as Add } from '../../assets/icons/add.svg';
import { ReactComponent as Delete } from '../../assets/icons/remove.svg';
import PhoneNumberInput from '../../components/utils/PhoneInput/PhoneNumberInput';
import { Waveform } from '@uiball/loaders';
import { ReactComponent as Edit } from '../../assets/icons/edit.svg';
import Button from '../../components/utils/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCancelSubscriptionPending,
  selectEditVendorPending,
  selectGetPaymentIntentsForVendorPending,
  selectSubscribeWithCouponPending,
  selectUserInfo,
  selectVendorsInfo,
} from '../../store/slice/vendor/slice';
import {
  cancelSubscription,
  editVendorInfo,
  getPaymentIntentsForVendor,
  subscribeWithCoupon,
} from '../../store/slice/vendor/asyncThunks';
import { notifyError, notifyErrorLeft, notifyInfo } from '../../utils/notify';
import GoogleMaps from '../../components/GoogleMaps/GoogleMaps';
import PaymentCardFormModal from '../../components/Modal/PaymentCardFormModal';
import HistoryModal from '../../components/Modal/HistoryModal';
import { dateFormatterSeparateWithDost, priceFormatter } from '../../utils/utils';
import { Elements } from '@stripe/react-stripe-js';
import { stripe } from '../../App';
import HamburgerSidebar from '../../components/HamburgerSidebar/HamburgerSidebar';
import AreYouSureModal from '../../components/Modal/AreYouSureModal';
import GalleryModal from '../../components/Modal/GalleryModal';
import {
  Background,
  ButtonContainerGap,
  ModalTitleSmall,
  SmallModalContainer,
} from '../../components/Modal/ModalComponent.styles';
import PromoCodeModal from '../../components/Modal/PromoCodeModal';
import { GOOGLE_API_KEY, GOOGLE_API_LIBRARY } from '../../utils/constants';
import { AutoCompleteInput } from '../OnboardingPages/SignupPage/SignupPage.styles';
import { useJsApiLoader } from '@react-google-maps/api';

const ProfilePage = () => {
  const dispatch = useDispatch();
  const [openGallery, setOpenGallery] = useState(false);
  const [clickedImage, setClickedImage] = useState('');
  const [images, setImages] = useState([]);

  const vendorInfo = useSelector(selectUserInfo);
  const vendor = useSelector(selectVendorsInfo);
  const [companyName, setCompanyName] = useState('');
  const [address, setAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState({ value: '', formattedValue: '' });
  const [websiteLink, setWebsiteLink] = useState('');
  const [instagram, setInstagram] = useState('');
  const [emailToShow, setEmailToShow] = useState('');
  const [facebook, setFacebook] = useState('');
  const [x, setX] = useState('');
  const [tiktok, setTiktok] = useState('');
  const [showAddress, setShowAddress] = useState();
  const [ytLinks, setYtLinks] = useState([]);
  const [ytLinksEmpty, setYtLinksEmpty] = useState(['']);
  const [selectedImages, setSelectedImages] = useState([]);
  const [imagesToSend, setImagesToSend] = useState([]);
  const [vendorImages, setVendorImages] = useState([]);
  const [newBannerImage, setNewBannerImage] = useState(null);
  const [googlePlaceId, setGooglePlaceId] = useState('');

  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [confirmCancelationModal, setConfirmCancelationModal] = useState(false);

  const [isDisabled, setIsDisabled] = useState(true);
  const [isVisible, setIsVisible] = useState(isDisabled);
  const editVendorPending = useSelector(selectEditVendorPending);
  const cancelSubscriptionPending = useSelector(selectCancelSubscriptionPending);
  const getPaymentIntentsForVendorPending = useSelector(selectGetPaymentIntentsForVendorPending);
  const [areYouSureModal, setAreYouSureModal] = useState(false);
  const [isVisibleDelete, setIsVisibleDelete] = useState(areYouSureModal);

  const [selectedImageForDelete, setSelectedImageForDelete] = useState(null);
  const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false);

  const subscribeWithCouponPending = useSelector(selectSubscribeWithCouponPending);

  useEffect(() => {
    setCompanyName(vendorInfo.name);
    setAddress(vendorInfo.address);
    setPhoneNumber({ value: vendorInfo.phoneNumber, formattedValue: vendorInfo.phoneNumber });
    setInstagram(vendorInfo.instagram);
    setFacebook(vendorInfo.facebook);
    setX(vendorInfo.twitter);
    setTiktok(vendorInfo.tiktok);
    setYtLinks(vendorInfo.links);
    setVendorImages(vendorInfo.photos);
    setShowAddress(vendorInfo.showAddress);
    setYtLinksEmpty(vendorInfo.links.length ? [] : ['']);
    setGooglePlaceId(vendorInfo.googlePlaceId ? vendorInfo.googlePlaceId : '');
    setWebsiteLink(vendorInfo.websiteLink);
    setEmailToShow(vendorInfo.emailToShow);
  }, [vendorInfo]);

  // useEffect(() => {
  //   dispatch(getPaymentIntentsForVendor({ page: 1 }));
  // }, [dispatch]);

  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    let timer;
    if (areYouSureModal) {
      setIsVisibleDelete(true);
    } else {
      timer = setTimeout(() => setIsVisibleDelete(false), 250);
    }

    return () => clearTimeout(timer);
  }, [areYouSureModal]);

  const handlePageChangePaymentsIntents = page => {
    dispatch(getPaymentIntentsForVendor({ page: page }));
  };

  const handleRemoveVendorYtLink = idToRemove => {
    setYtLinks(prevYtLinks => prevYtLinks.filter(links => links.id !== idToRemove));
    if (ytLinks.length === 1 && !ytLinksEmpty.length) {
      setYtLinksEmpty(['']);
    }
  };

  const handleAddYtLinkEmpty = () => {
    if (ytLinksEmpty.length <= 4) {
      setYtLinksEmpty([...ytLinksEmpty, '']);
    }
  };
  const handleRemoveYtLinkEmpty = indexToRemove => {
    setYtLinksEmpty(prevYtLinks => prevYtLinks.filter((_, index) => index !== indexToRemove));
  };

  const showAddIcon = (index, isFromEmpty) => {
    if (isFromEmpty) {
      return index === ytLinksEmpty.length - 1 && ytLinksEmpty.length < 3;
    } else {
      return ytLinks.length < 3 && index === ytLinks.length - 1 && ytLinks.length + ytLinksEmpty.length < 3;
    }
  };

  const handleOnChangeLinksUrl = (id, value) => {
    setYtLinks(prev =>
      prev.map(link => {
        if (link.id === id) {
          return { ...link, url: value };
        }

        return link;
      }),
    );
  };

  // Function to handle file input change
  const handleFileInputChange = e => {
    const selectedFiles = e.target.files;
    const selectedImagesArray = [];
    const imagesArray = [];
    let isAnyBigger = false;

    for (let i = 0; i < selectedFiles.length; i++) {
      const imageFile = selectedFiles[i];
      if (imageFile.size > 3e6) {
        // console.log('bigger');
        isAnyBigger = true;
      } else {
        // console.log('smaller');
        selectedImagesArray.push(URL.createObjectURL(imageFile));
        imagesArray.push(imageFile);
      }
    }
    if (isAnyBigger) {
      notifyError('Max size of image is 3MB');
    }

    // Calculate the total number of selected images
    const totalImages = selectedImages.length + selectedImagesArray.length + vendorImages.length;

    if (totalImages >= 5 && totalImages <= 20) {
      setSelectedImages(prevSelectedImages => [...prevSelectedImages, ...selectedImagesArray]);

      setImagesToSend(prev => [...prev, ...imagesArray]);
    } else {
      alert('The number of images must be between 5 to 20 images.');
    }
  };

  const handleRemoveSelectedImage = indexToRemove => {
    setSelectedImages(prevSelectedImages => prevSelectedImages.filter((_, index) => index !== indexToRemove));
    setImagesToSend(prevSelectedImages => prevSelectedImages.filter((_, index) => index !== indexToRemove));
  };

  const handleRemoveVendorImage = idToRemove => {
    setVendorImages(prevImages => prevImages.filter(image => image.id !== idToRemove));
    setSelectedImageForDelete(null);
    setAreYouSureModal(false);
  };

  const handleSelectBannerImage = e => {
    if (e.target.files.length) {
      setNewBannerImage({
        file: e.target.files[0],
      });
    }
  };
  const handleEdit = () => {
    dispatch(
      editVendorInfo({
        images: imagesToSend,
        banner: newBannerImage,
        name: companyName,
        address: address,
        showAddress: showAddress,
        photos: vendorImages,
        ...(instagram && { instagram }),
        ...(facebook && { facebook }),
        ...(x && { twitter: x }),
        ...(tiktok && { tiktok }),
        ...(websiteLink && { websiteLink }),
        links: ytLinks,
        newLinks: ytLinksEmpty,
        phoneNumber: phoneNumber.value,
        googlePlaceId,
        emailToShow,
      }),
    )
      .unwrap()
      .then(() => {
        notifyInfo('Successfully edited data!');
        setNewBannerImage(null);
        setSelectedImages([]);
        setImagesToSend([]);
        setIsDisabled(true);
      })
      .catch(err => {
        notifyError(err.message);
      });
  };

  const handleCancel = () => {
    dispatch(cancelSubscription())
      .unwrap()
      .then(() => {
        setConfirmCancelationModal(false);
        notifyInfo('Successfully canceled subscription!');
      })
      .catch(err => {
        notifyError(err.message);
      });
  };

  const handleOpenGallery = ({ images, index }) => {
    setClickedImage(index);
    setImages(images);
    setOpenGallery(true);
  };

  useEffect(() => {
    let timer;
    if (isDisabled) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 200);
    }

    return () => clearTimeout(timer);
  }, [isDisabled]);

  const handleSubscribeWithPromoCode = code => {
    dispatch(subscribeWithCoupon({ code }))
      .unwrap()
      .then(() => {
        setSubscriptionModalOpen(false);
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_API_KEY,
    libraries: GOOGLE_API_LIBRARY,
  });

  return (
    <Container>
      <Sidebar />
      <HamburgerSidebar />
      <ContentContainer>
        <Header title={'Profile'} />
        <ProfileContainer>
          <LeftSide $edit={!isDisabled}>
            {!vendor.gettingVendorInfo ? (
              <>
                <EditContainer>
                  <Title>Information</Title>
                  {isDisabled ? (
                    <Edit className="icon-edit" onClick={() => setIsDisabled(!isDisabled)} />
                  ) : (
                    <CloseIcon onClick={() => setIsDisabled(!isDisabled)} />
                  )}
                </EditContainer>
                <StyledInput
                  placeholder={'Company Name'}
                  value={companyName}
                  onChange={e => setCompanyName(e.target.value)}
                  disabled={isDisabled}
                />
                {/* <StyledInput
                  placeholder={'Address'}
                  value={address}
                  onChange={e => setAddress(e.target.value)}
                  disabled={isDisabled}
                /> */}

                {isLoaded && (
                  <AutoCompleteInput
                    apiKey={GOOGLE_API_KEY}
                    options={{
                      types: ['geocode', 'establishment'],
                    }}
                    // libraries={['places']}
                    placeholder="Address"
                    defaultValue={address}
                    onPlaceSelected={place => {
                      setAddress(place.formatted_address);
                    }}
                    disabled={isDisabled}
                  />
                )}
                <TextDescAddress>
                  You must select an address from the drop-down menu that appears after entering your address
                </TextDescAddress>
                <CheckboxContainer onClick={() => !isDisabled && setShowAddress(!showAddress)}>
                  <Checkbox checked={!showAddress} width={18} height={18} stroke={'black'} />
                  <Text>Show Address</Text>
                </CheckboxContainer>

                <PhoneNumberInput phone={phoneNumber} setPhone={setPhoneNumber} disabled={isDisabled} />
                <StyledInput
                  // icon={true}
                  // leftIcon={<Instagram opacity={instagram !== '' ? 1 : 0.5} className="icon" />}
                  disabled={isDisabled}
                  placeholder={'Email for clients'}
                  value={emailToShow}
                  onChange={e => setEmailToShow(e.target.value)}
                />
                <StyledInput
                  icon={true}
                  leftIcon={<Instagram opacity={instagram !== '' ? 1 : 0.5} className="icon" />}
                  disabled={isDisabled}
                  placeholder={'username'}
                  value={instagram}
                  onChange={e => setInstagram(e.target.value)}
                />
                <StyledInput
                  placeholder={'username'}
                  icon={true}
                  leftIcon={<Facebook opacity={facebook !== '' ? 1 : 0.5} className="icon" />}
                  disabled={isDisabled}
                  value={facebook}
                  onChange={e => setFacebook(e.target.value)}
                />
                <StyledInput
                  placeholder={'username'}
                  icon={true}
                  leftIcon={<X opacity={x !== '' ? 1 : 0.5} className="icon" />}
                  value={x}
                  onChange={e => setX(e.target.value)}
                  disabled={isDisabled}
                />
                <StyledInput
                  placeholder={'username'}
                  icon={true}
                  leftIcon={<Tiktok opacity={tiktok !== '' ? 1 : 0.5} className="icon" />}
                  value={tiktok}
                  onChange={e => setTiktok(e.target.value)}
                  disabled={isDisabled}
                />
                <StyledInput
                  icon={true}
                  leftIcon={<Website opacity={websiteLink !== '' ? 1 : 0.5} className="icon" />}
                  placeholder={'yourwebsite.com'}
                  value={websiteLink}
                  onChange={e => setWebsiteLink(e.target.value)}
                  disabled={isDisabled}
                />
                <SubTitle>Banner Photo</SubTitle>
                {!newBannerImage && <img src={vendorInfo.bannerPhoto} alt="bannerPhoto" className="banner" />}

                {!isVisible && (
                  <Fade $open={!isDisabled}>
                    <div style={{ position: 'relative' }}>
                      {newBannerImage && (
                        <ImageContainer>
                          <img src={URL.createObjectURL(newBannerImage.file)} alt="SelectedImage" className="banner" />
                          <Delete onClick={() => setNewBannerImage(null)} className="icon-delete" />
                        </ImageContainer>
                      )}

                      <Button
                        width
                        title={'Upload New Banner Photo'}
                        containerStyle={{
                          background: '#f1e4df',
                          boxShadow: 'none',
                        }}
                        titleStyle={{ color: '#000', textDecoration: 'underline' }}
                      />

                      <UploadInputSmall
                        type="file"
                        onChange={e => handleSelectBannerImage(e)}
                        accept=".jpg, .jpeg, .png"
                      />
                    </div>

                    <Button
                      width
                      title={'Save'}
                      onClick={handleEdit}
                      loading={editVendorPending}
                      disabled={
                        !companyName ||
                        !address ||
                        !phoneNumber.value ||
                        (!vendorImages.length && !imagesToSend.length) ||
                        editVendorPending ||
                        !emailToShow ||
                        !validateEmail(emailToShow)
                      }
                    />
                  </Fade>
                )}
              </>
            ) : (
              <LoaderContainer>
                <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
              </LoaderContainer>
            )}
          </LeftSide>
          <StyledColumn>
            <BankCard>
              <TitleContainer>
                <Title>Subscription</Title>

                <UnderLineText
                  onClick={() => {
                    setHistoryModal(true);
                    dispatch(getPaymentIntentsForVendor({ page: 1 }));
                  }}>
                  History
                </UnderLineText>
              </TitleContainer>
              <Row>
                <Column>
                  <StyledText>Payment Method</StyledText>
                  {vendorInfo.paymentMethod && (
                    <StyledText $bold>
                      {vendorInfo.paymentMethod.brand + ' ****' + vendorInfo.paymentMethod.last4}
                    </StyledText>
                  )}
                </Column>
                <Column>
                  <StyledText>{vendorInfo.subscription ? 'Subscription' : 'Not subscribed'}</StyledText>
                  <StyledText $bold>
                    {vendorInfo.subscription
                      ? vendorInfo.subscription.canceledAt
                        ? `Active until ${dateFormatterSeparateWithDost(vendorInfo.hasSubscriptionTo)}`
                        : `Next payment ${dateFormatterSeparateWithDost(vendorInfo.hasSubscriptionTo)}`
                      : `Listing active until ${dateFormatterSeparateWithDost(vendorInfo.hasSubscriptionTo)}`}
                  </StyledText>
                </Column>
              </Row>
              <Column>
                <StyledText>Plan</StyledText>
                {vendorInfo.subscription && (
                  <StyledText $bold>{`$${priceFormatter(vendorInfo.subscription.amount)}`}</StyledText>
                )}
              </Column>
              <ButtonContainer>
                {vendorInfo.subscription && (
                  <StyledButton
                    disabled={vendorInfo.subscription && vendorInfo.subscription.canceledAt}
                    onClick={() => setConfirmCancelationModal(true)}>
                    <XIcon />
                    <ButtonText $disabled={vendorInfo.subscription && vendorInfo.subscription.canceledAt}>
                      Cancel
                    </ButtonText>
                  </StyledButton>
                )}
                <StyledButton $black onClick={() => setPaymentModalOpen(true)}>
                  <CardIcon />
                  <ButtonText $black>
                    {vendorInfo.paymentMethod && vendorInfo.subscription && !vendorInfo.subscription.canceledAt
                      ? 'Change Payment'
                      : 'Subscribe'}
                  </ButtonText>
                </StyledButton>
                {!vendorInfo.hasCoupon && (
                  <StyledButton $black onClick={() => setSubscriptionModalOpen(true)}>
                    <CardIcon />
                    <ButtonText $black>{'Promo Code'}</ButtonText>
                  </StyledButton>
                )}
              </ButtonContainer>
            </BankCard>
            <MediaCard>
              {!vendor.gettingVendorInfo ? (
                <>
                  <EditContainer>
                    <Title>Media</Title>

                    {isDisabled ? (
                      <Edit className="icon-edit" onClick={() => setIsDisabled(!isDisabled)} />
                    ) : (
                      <CloseIcon onClick={() => setIsDisabled(!isDisabled)} />
                    )}
                  </EditContainer>
                  <UploadContainer onClick={() => {}}>
                    {vendorInfo?.photos?.length === 0 ? (
                      <>
                        <UploadInputBig
                          multiple
                          onChange={handleFileInputChange}
                          type="file"
                          accept=".jpg, .jpeg, .png"
                        />

                        <Column2>
                          <AddPhoto />
                          <Text2>Upload Photos</Text2>
                          <Row2>
                            <UnderlineText2>Click here</UnderlineText2>
                            <Text2>or Drag</Text2>
                          </Row2>
                        </Column2>
                        <ThinText>Min 5 photos, Max 20 photos.</ThinText>
                      </>
                    ) : (
                      <ImagesContainer>
                        {vendorImages.map((image, index) => (
                          <IconContainer key={image.id}>
                            <img
                              onClick={() => handleOpenGallery({ images: vendorImages, index: index })}
                              style={{
                                width: 80,
                                borderRadius: 10,
                                height: 80,
                                userSelect: 'none',
                              }}
                              src={image.url}
                              alt={`Selected ${index + 1}`}
                            />
                            {!isDisabled && (
                              <Minus
                                onClick={() => {
                                  setSelectedImageForDelete(image.id);
                                  // handleRemoveVendorImage(image.id);
                                  setAreYouSureModal(true);
                                }}
                                style={{
                                  position: 'absolute',
                                  right: -1,
                                  top: 2,
                                  cursor: 'pointer',
                                }}
                              />
                            )}
                          </IconContainer>
                        ))}

                        {selectedImages.map((image, index) => (
                          <IconContainer key={index}>
                            <img
                              style={{
                                width: 80,
                                borderRadius: 10,
                                height: 80,
                                userSelect: 'none',
                              }}
                              key={index}
                              src={image}
                              alt={`Selected ${index + 1}`}
                            />
                            <Minus
                              onClick={() => handleRemoveSelectedImage(index)}
                              style={{
                                position: 'absolute',
                                right: -1,
                                top: 2,
                                cursor: 'pointer',
                              }}
                            />
                          </IconContainer>
                        ))}
                        {selectedImages.length + vendorImages.length < 20 && !isDisabled && (
                          <AddPhotoContainer $open={!isDisabled}>
                            <AddPhoto />
                            <UploadInput
                              multiple
                              onChange={handleFileInputChange}
                              type="file"
                              accept=".jpg, .jpeg, .png"
                            />
                          </AddPhotoContainer>
                        )}
                      </ImagesContainer>
                    )}
                  </UploadContainer>
                  <InputContainer>
                    {ytLinks.length === 0 ? (
                      ytLinksEmpty.map((ytLink, index) => (
                        <AddInputContainer key={index}>
                          <StyledInput
                            icon={true}
                            leftIcon={<Youtube opacity={ytLink !== '' ? 1 : 0.5} className="icon" />}
                            placeholder={'youtube.com/yourvideo'}
                            value={ytLink}
                            disabled={isDisabled}
                            onChange={e => {
                              const updatedYtLinks = [...ytLinksEmpty];
                              updatedYtLinks[index] = e.target.value;
                              setYtLinksEmpty(updatedYtLinks);
                            }}
                          />
                          {!isDisabled && (
                            <IconsContainer>
                              {index > 0 && (
                                <Delete className="icon-delete" onClick={() => handleRemoveYtLinkEmpty(index)} />
                              )}
                              {showAddIcon(index, true) && (
                                <Add className="icon-add" onClick={ytLink !== '' ? handleAddYtLinkEmpty : null} />
                              )}
                            </IconsContainer>
                          )}
                        </AddInputContainer>
                      ))
                    ) : (
                      <>
                        {ytLinks.map((ytLink, index) => {
                          return (
                            <AddInputContainer key={ytLink.id}>
                              <InputLink
                                icon={true}
                                leftIcon={<Youtube opacity={ytLink !== '' ? 1 : 0.5} className="icon" />}
                                placeholder={'youtube.com/yourvideo'}
                                value={ytLink.url}
                                disabled={isDisabled}
                                onChange={e => {
                                  handleOnChangeLinksUrl(ytLink.id, e.target.value);
                                }}
                              />
                              {!isDisabled && (
                                <IconsContainer>
                                  <Delete
                                    className="icon-delete"
                                    onClick={() => handleRemoveVendorYtLink(ytLink.id, index)}
                                  />

                                  {showAddIcon(index, false) && (
                                    <Add className="icon-add" onClick={ytLink !== '' ? handleAddYtLinkEmpty : null} />
                                  )}
                                </IconsContainer>
                              )}
                            </AddInputContainer>
                          );
                        })}
                        {ytLinksEmpty.length !== 0 &&
                          ytLinksEmpty.map((ytLink, index) => {
                            return (
                              <AddInputContainer key={index}>
                                <InputLink
                                  icon={true}
                                  leftIcon={<Youtube opacity={ytLink !== '' ? 1 : 0.5} className="icon" />}
                                  placeholder={'youtube.com/yourvideo'}
                                  value={ytLink}
                                  disabled={isDisabled}
                                  onChange={e => {
                                    const updatedYtLinks = [...ytLinksEmpty];
                                    updatedYtLinks[index] = e.target.value;
                                    setYtLinksEmpty(updatedYtLinks);
                                  }}
                                />
                                {!isDisabled && (
                                  <IconsContainer>
                                    <Delete className="icon-delete" onClick={() => handleRemoveYtLinkEmpty(index)} />
                                    {showAddIcon(index, false) && (
                                      <Add className="icon-add" onClick={ytLink !== '' ? handleAddYtLinkEmpty : null} />
                                    )}
                                  </IconsContainer>
                                )}
                              </AddInputContainer>
                            );
                          })}
                      </>
                    )}
                  </InputContainer>
                </>
              ) : (
                <LoaderContainer>
                  <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
                </LoaderContainer>
              )}
            </MediaCard>
          </StyledColumn>

          <RightSide>
            {!vendor.gettingVendorInfo ? (
              <>
                <EditContainer>
                  <Title>Location</Title>
                  {isDisabled ? (
                    <Edit className="icon-edit" onClick={() => setIsDisabled(!isDisabled)} />
                  ) : (
                    <CloseIcon onClick={() => setIsDisabled(!isDisabled)} />
                  )}
                </EditContainer>
                <StyledInput
                  placeholder={'Place Id'}
                  value={googlePlaceId}
                  onChange={e => setGooglePlaceId(e.target.value)}
                  disabled={true}
                />
                <GoogleMaps
                  setPlaceId={setGooglePlaceId}
                  centerLat={vendorInfo.googlePlaceLat}
                  centerLong={vendorInfo.googlePlaceLong}
                  viewOnly={isDisabled}
                />
              </>
            ) : (
              <LoaderContainer>
                <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
              </LoaderContainer>
            )}
          </RightSide>
        </ProfileContainer>
      </ContentContainer>
      <Elements stripe={stripe}>
        <PaymentCardFormModal
          width={'620px'}
          height={'543px'}
          modalOpen={paymentModalOpen}
          onClose={() => {
            setPaymentModalOpen(false);
          }}
          stripe={stripe}
        />
      </Elements>
      <HistoryModal
        width={'620px'}
        open={historyModal}
        loading={getPaymentIntentsForVendorPending}
        onClose={() => {
          setHistoryModal(false);
        }}
        onPageChange={handlePageChangePaymentsIntents}
      />
      <PromoCodeModal
        width={'806px'}
        height={'500px'}
        modalOpen={subscriptionModalOpen}
        subscribeWithPromoCode={handleSubscribeWithPromoCode}
        loading={subscribeWithCouponPending}
        onClose={() => {
          setSubscriptionModalOpen(false);
        }}
      />
      <AreYouSureModal
        open={confirmCancelationModal}
        onClose={() => {
          setConfirmCancelationModal(false);
        }}
        width={'480px'}
        height={'200px'}
        onClick={handleCancel}
        loading={cancelSubscriptionPending}
      />
      <GalleryModal
        open={openGallery}
        onClose={() => {
          setOpenGallery(false);
        }}
        width={'50%'}
        height={'50%'}
        images={images}
        index={clickedImage}
        onClickDelete={handleRemoveVendorImage}
        edit={!isDisabled}
        deleteLoading={editVendorPending}
      />

      {isVisibleDelete && (
        <>
          <Background $open={areYouSureModal} $bg />
          <SmallModalContainer $open={areYouSureModal}>
            <ModalTitleSmall style={{ textAlign: 'center' }}>
              Are you sure you want to delete this photo?
            </ModalTitleSmall>
            <ButtonContainerGap style={{ gap: 20 }}>
              <StyledButton onClick={() => setAreYouSureModal(false)}>
                <ButtonText>Cancel</ButtonText>
              </StyledButton>

              <StyledButton
                onClick={() => {
                  handleRemoveVendorImage(selectedImageForDelete);
                }}
                // $disabled={deleteDocumentPending}
                $black>
                <ButtonText $black>Yes</ButtonText>
              </StyledButton>
            </ButtonContainerGap>
          </SmallModalContainer>
        </>
      )}
    </Container>
  );
};

export default ProfilePage;
